<template>
  <div v-if="resources.length" class="">
    <div class="shared-table-innermost-container">
      <table class="shared-table">
        <thead>
          <tr class="bg-transparent border-none shared-table-headings">
            <th
              v-for="(header, index) in $options.tableHeaders"
              :key="`heading-${index}`"
              class="shared-table-headings-heading"
            >
              <div class="flex items-center justify-center">
                {{ header }}
              </div>
            </th>
            <th class="shared-table-headings-heading"></th>
          </tr>
        </thead>
        <tbody>
          <!-- resources existing in database -->
          <tr v-for="(r, index) in resources" :key="`resource-${index}`" class="shared-table-cells">
            <td class="shared-table-cells-cell">
              <div class="w-40 truncate">{{ r.title }}</div>
            </td>
            <td class="truncate whitespace-normal shared-table-cells-cell">
              <div class="w-40 truncate">
                <span v-if="r.link">{{ r.link }}</span>
                <a v-else :href="r.file_path" target="_blank" :download="r.title" class="underline">
                  pdf file
                </a>
              </div>
            </td>
            <td class="shared-table-cells-cell">
              <div class="flex justify-center">
                <button class="mr-2 shared-table-cells-button round edit" @click="$emit('edit', r)">
                  <VSvgIcon name="pencil" class="h-5" />
                </button>
                <button
                  class="shared-table-cells-button round delete"
                  @click="$emit('delete', r.id)"
                >
                  <VSvgIcon name="trash" class="h-5" />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div
    v-else
    class="flex items-center justify-center w-full h-full text-lg border rounded border-ricoma-gray-300"
  >
    <span>There are not resources for</span>
    <span class="ml-1 font-bold">{{ serie.name }}</span>
  </div>
</template>

<script>
import VSvgIcon from '@/components/base/VSvgIcon';
export default {
  name: 'ResourcesTable',
  components: { VSvgIcon },
  props: {
    resources: {
      type: Array,
      required: true,
    },
    serie: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  created() {
    this.$options.tableHeaders = ['title', 'file/link name', 'actions'];
  },
  tableHeaders: [],
};
</script>
